module.exports = __webpack_public_path__ + "img/index.107be2e1.png";